import echarts from 'echarts';
import localforage from 'localforage';
import axios from 'axios';
import difference from 'lodash/difference';
import bus from '../util/bus';
import MessagingService from '../centrifugo/chat';
// import { getTimestamp } from '../util/timeLib';
function getChatEvent({ commit, state, dispatch }) {
  return {
    message(dataset) {
      const msg = dataset.data;
      if (msg.kind === 4) {
        commit('addMsg', msg.chatLine);
        if (msg.chatLine.fromUserId !== state.currentUser.userid) {
          if (state.chatMode === 'list' ||
          (state.chatUser.userId && state.chatUser.userId !== msg.chatLine.fromUserId)) {
            if (('Notification' in window)) {
              const audio = new Audio('./static/bubbling-up.mp3');
              if (window.Notification.permission === 'granted') {
                const n = new window.Notification(`Message from ${msg.chatLine.fromUserId}`,
                  { // eslint-disable-line no-new
                    body: msg.chatLine.msg,
                    icon: './static/mrc.gif',
                    silent: true,
                  });
                audio.play();
                setTimeout(n.close.bind(n), 3800);
              } else if (window.Notification.permission !== 'denied') {
                window.Notification.requestPermission((permission) => {
                  if (permission === 'granted') {
                    const n = new window.Notification(
                  `Message from ${msg.chatLine.fromUserId}`, { // eslint-disable-line no-new
                    body: msg.chatLine.msg,
                    icon: './static/mrc.gif',
                    silent: true,
                  });
                    audio.play();
                    setTimeout(n.close.bind(n), 3800);
                  }
                });
              }
            }
          } else if (state.chatActive && state.chatMode === 'chat'
          && (state.chatUser.userId && state.chatUser.userId === msg.chatLine.fromUserId)) {
            dispatch('setReadTimestamp', [msg.chatLine]);
          }
          if (msg.chatLine.fromUserId === 'mrcchatbot@mrc-asia.com') {
            commit('setChatChoices', msg.chatLine.choices || []);
          }
        }
        if (state.chatActive && state.chatMode === 'chat'
            && state.chatUser.userId
            && (state.chatUser.userId === msg.chatLine.fromUserId
            || state.chatUser.userId === msg.chatLine.toUserId)) {
          bus.$emit('scrollChatToEnd');
        }
      } else if (msg.kind === 5) {
        msg.msges.forEach(m => commit('setRead', m));
      }
    },
    error(errContext) {
      console.log(`ERROR: ${JSON.stringify(errContext)}`); // eslint-disable-line
    },
  };
}
function getPresenceEvents({ commit }) {
  return {
    subscribe() {
      this.presence().then((context) => {
        commit('addOnlineContacts', Object.keys(context.data).map(key => context.data[key].default_info));
      }, (err) => {
        console.log(err); // eslint-disable-line
      });
    },
    join(context) {
      commit('addOnlineContacts', [context.data.default_info]);
    },
    leave(context) {
      commit('removeOnlineContact', context.data.user);
    },
  };
}
const actions = {
  disableChat({ commit, state }) {
    commit('setChatStatus', false);
    MessagingService.unsubscribe('presence:chat');
    MessagingService.unsubscribe(`chat#${state.currentUser.userid}`);
    axios.post('/aims/api/handleMessage', { kind: 7 });
  },
  enableChat({ commit, state, dispatch }) {
    commit('setChatStatus', true);
    axios.post('/aims/api/handleMessage', {
      kind: 6,
      user: {
        userId: state.currentUser.userid,
        userName: state.currentUser.username,
        company: state.currentUser.company,
      },
    });
    MessagingService.addSubscription(`chat#${state.currentUser.userid}`, getChatEvent({ state, commit, dispatch }));
    MessagingService.addSubscription('presence:chat', getPresenceEvents({ commit }));
  },
  initChat({ state, commit, dispatch }) {
    MessagingService.configure({
      url: 'https://centrifugo.mrc-asia.com/connection',
      user: state.currentUser.userid,
      timestamp: state.cent.timestamp,
      token: state.cent.token,
      info: state.cent.info,
    });
    MessagingService.addSubscription(`chat#${state.currentUser.userid}`, getChatEvent({ state, commit, dispatch }));
    MessagingService.addSubscription('presence:chat', getPresenceEvents({ commit }));
    MessagingService.start();
  },
  chatWith({ commit, state, dispatch }, user) {
    if (!state.userChatLogPulled[user.userId]) {
      dispatch('getUserMsges', user.userId);
    }
    commit('setChatUser', user);
  },
  sendMessage({ commit, state }, { msg, toUserId }) {
    const now = new Date();
    const chatLine = {
      msg,
      fromUserId: state.currentUser.userid,
      toUserId,
      timestamp: now.toISOString(),
    };
    return axios.post('/aims/api/handleMessage', { kind: 4, chatLine });
  },
  getChatStatus({ commit }) {
    return axios.get('/aims/api/chatStatus')
      .then((res) => {
        commit('setChatStatus', res.data);
        return res.data;
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setTimeout(() => {
            window.location.href = '/sign/in?source=/aims';
          }, 500);
        }
      });
  },
  getAllContacts({ commit }) {
    axios.get('/aims/api/allContacts')
      .then((res) => {
        commit('setContacts', res.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setTimeout(() => {
            window.location.href = '/sign/in?source=/aims';
          }, 500);
        }
      });
  },
  getCurrencies({ commit, state }, currencies) {
    const existing = state.currencyExchangeRates.map(c => c.currencyCode);
    const newCur = difference(currencies, existing);
    if (newCur.length === 0) return;
    axios.post('/aims/api/economy/currencies', newCur)
      .then((res) => {
        commit('addCurrencyExchangeRates', res.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setTimeout(() => {
            window.location.href = '/sign/in?source=/aims';
          }, 500);
        }
      });
  },
  setReadTimestamp({
    commit,
  }, msges) {
    const now = new Date();
    const readMsges = msges.map(m => ({
      ...m,
      readTimestamp: now,
    }));
    axios.post('/aims/api/handleMessage', { kind: 5, msges: readMsges });
  },
  getUnreadMsges({
    commit,
  }) {
    axios.get('/aims/api/unreadMsges')
      .then((res) => {
        if (res.data) {
          commit('setUnreadMsges', res.data);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setTimeout(() => {
            window.location.href = '/sign/in?source=/aims';
          }, 500);
        }
      });
  },
  getUserMsges({
    commit, state,
  }, userId) {
    return axios.get(`/aims/api/msg/${userId}`)
      .then((res) => {
        if (res.data) {
          commit('setMsges', { userId, msges: res.data });
          if (state.chatActive && state.chatMode === 'chat'
              && state.chatUser.userId === userId) {
            bus.$emit('scrollChatToEnd');
          }
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setTimeout(() => {
            window.location.href = '/sign/in?source=/aims';
          }, 500);
        }
      });
  },
  initEchartsMap() {
    const mapStorage = localforage.createInstance({
      name: 'Map',
    });
    mapStorage.getItem('worldMap')
      .then((map) => {
        if (!map) {
          axios.get('/aims/static/world.json')
            .then((res) => {
              mapStorage.setItem('worldMap', res.data);
              echarts.registerMap('world', res.data);
              bus.$emit('mapRegistered');
            });
        } else {
          echarts.registerMap('world', map);
          bus.$emit('mapRegistered');
        }
      });
    mapStorage.getItem('asiaMap')
      .then((map) => {
        if (!map) {
          axios.get('/aims/static/asia.json')
            .then((res) => {
              mapStorage.setItem('asiaMap', res.data);
              echarts.registerMap('asia', res.data);
              bus.$emit('asiaMapRegistered');
            });
        } else {
          echarts.registerMap('asia', map);
          bus.$emit('asiaMapRegistered');
        }
      });
  },

  getCurrentUser({
    commit,
  }) {
    return axios.get('/aims/api/currentUser')
      .then((res) => {
        commit('setCurrentUser', res.data.currentUser);
        commit('setCurrentUserCountry', res.data.currentUserCountry);
        commit('setCent', res.data.cent);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setTimeout(() => {
            window.location.href = '/sign/in?source=/aims';
          }, 500);
        }
      });
  },

  logout() {
    axios.get('/sign/out')
      .then(() => {
        window.location.href = '/aims';
      });
  },
};
export default actions;



// WEBPACK FOOTER //
// ./src/store/actions.js